<template>
    <Card class="card" @submitted="updateEmployeeInformation">
        <template #title>
            Profil Karyawan
        </template>

        <template #content>
            <div class="mb-5">
                Lihat Data Pribadi Kamu Disini
            </div>

            <Image :src="form.foto" preview="true" width="250" />

            <div class="field">
                <label for="name">Nomor KTP</label>
                <InputText
                    id="name"
                    class="w-full"
                    :class="{'p-invalid': form.errors.id_card_number}"
                    type="text"
                    v-model="form.id_card_number"
                />
                <small v-if="form.errors.id_card_number" class="p-invalid">
                    {{ form.errors.id_card_number }}
                </small>
            </div>

            <div class="field">
                <label for="name">Nama</label>
                <InputText
                    id="name"
                    class="w-full"
                    :class="{'p-invalid': form.errors.name}"
                    type="text"
                    v-model="form.name"
                />
                <small v-if="form.errors.name" class="p-invalid">
                    {{ form.errors.name }}
                </small>
            </div>

            <div class="field">
                <label for="gender">Jenis Kelamin</label>
                <Dropdown v-model="form.gender" :options="genders" optionLabel="name" optionValue="code"
                    placeholder="Pilih Jenis Kelamin" :class="{
                        'p-invalid':
                            submitted && !form.gender,
                        'w-full': true
                    }" />
                <small class="p-invalid" v-if="submitted && !form.gender">Gender Perlu Diisi.</small>
            </div>

            <div class="field">
                <label for="name">Tempat Lahir</label>
                <InputText
                    id="name"
                    class="w-full"
                    :class="{'p-invalid': form.errors.birthplace}"
                    type="text"
                    v-model="form.birthplace"
                />
                <small v-if="form.errors.birthplace" class="p-invalid">
                    {{ form.errors.birthplace }}
                </small>
            </div>

            <div class="field">
                <label for="birthdate">Tanggal Lahir</label>
                <Calendar :showIcon="true"
                    :showButtonBar="true"
                    :class="{'p-invalid' : submitted && !form.birthdate, 'w-full' : true }"
                    v-model="form.birthdate"
                    dateFormat="yy-mm-dd"
                    disabled="true" />
                <small class="p-invalid" v-if="submitted && !form.birthdate"
                    >{{ $t('start-date') }} is required.</small
                >
            </div>
            <div class="field">
                <label for="address">Alamat</label>
                    <Textarea id="address" name="address" v-model="form.address" required="true" rows="5" cols="50" :class="{
                        'p-invalid':
                            submitted && !form.address,
                        'w-full': true
                    }">
                                        </Textarea>
                    <small class="p-invalid" v-if="submitted && !form.address">Alamat Perlu Diisi.</small>
            </div>

            <Divider />

            <div class="field">
                <label for="name">Posisi : </label>
                <b>{{ form.position }}</b>
            </div>

            <div class="field">
                <label for="name">Lokasi Kerja : </label>
                <b>{{ form.placement }}</b>
            </div>

            <div class="field">
                <label for="name">Mulai Aktif Kerja : </label>
                <b>{{ form.start_date }}</b>
            </div>
        </template>

        <template #footer>
            <!-- <Button
                label="Update"
                :loading="form.processing"
                @click="updateEmployeeInformation"
            /> -->
            Jika ada kesalahan data, harap menghubungi PIC
        </template>
    </Card>
</template>

<script>
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Divider from 'primevue/divider';
import Dropdown from "primevue/dropdown";
import Image from "primevue/image";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Textarea from "primevue/textarea";
import moment from "moment";
import FlashMessage from "../../../Services/FlashMessage";
import axios from "axios";

export default {
    components: {
        Calendar,
        Card,
        Divider,
        Dropdown,
        Image,
        InputText,
        Button,
        Textarea,
    },
    props: ['employement_info'],
    mixins: [FlashMessage],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'PUT',
                id: this.employement_info.id,
                id_card_number: this.employement_info.id_card_number,
                name: this.employement_info.name,
                birthplace: this.employement_info.birthplace,
                birthdate: moment(this.employement_info.birthdate).format('YYYY-MM-DD'),
                gender: this.employement_info.gender,
                address: this.employement_info.detail.address,
                position: this.employement_info.position.name,
                placement: this.employement_info.placement.name,
                foto: this.employement_info.foto,
                start_date: moment(this.employement_info.salary.start_date).format('DD MMMM YYYY'),
            }),
            genders: [
                { name: "Laki-Laki", code: "Laki-laki" },
                { name: "Perempuan", code: "Perempuan" },
            ],
            photoPreview: null,
        }
    },

    methods: {
        updateEmployeeInformation(){
            this.form.put(`${this.$page.props.appUrl}user/employement-information/${this.form.id}`, {
                errorBag: 'updateEmployeeInformation',
                preserveScroll: true,
                onSuccess: (response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Employement Info Updated",
                        life: 3000,
                    });
                },
                onerror: (errors) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                }
            });
        },
    },
}
</script>
